<template>
    <div class="kombi-tooltip">
        <div v-if="isQuotation && !isVendaDireta && !isConsumoProprio" class="tooltip-header quotation">
            Produtos na Minha Cotação
        </div>
        <div v-else-if="isVendaDireta && isQuotation && !isConsumoProprio" class="tooltip-header quotation">
            Produtos na Minha Cotação de Venda Direta
        </div>
        <div v-else-if="isConsumoProprio && !isVendaDireta && isQuotation" class="tooltip-header quotation">
            Produtos na Minha Cotação de Ativo/Imobilizado
        </div>
        <div v-else-if="isVendaDireta && !isQuotation && !isConsumoProprio" class="tooltip-header">
            Produtos no Meu Carrinho de Venda Direta
        </div>
        <div v-else-if="isConsumoProprio && !isVendaDireta && !isQuotation" class="tooltip-header">
            Produtos no Meu Carrinho de Ativo/Imobilizado
        </div>
        <div v-else class="tooltip-header">
            Produtos no Meu Carrinho
        </div>
        <Loader v-if="loading"/>
        <div v-else-if="hasKombi" class="tooltip-body">
            <div  class="row">
                <div  class="col-md-12">
                    <div class="product-list">
                        <table v-if="isQuotation" style="width:100%">
                            <tr v-for="(product, index) in productList" :key="'tooltip-prod' + index" class="tooltip-table-data quotation">
                                <td class="text-center"><a class="fa fa-times fa-lg" style="color:red" v-on:click.prevent="removeProduct(index)"/></td>
                                <td><strong>{{product.qtd}}</strong></td>
                                <td class="text-center tooltip-img"><img :src="product.imgSrc"></td>
                                <td class="tooltip-description"><strong>{{product.descr}}</strong></td>
                                <td class="text-center"><strong>{{formatCurrency(product.price)}}</strong></td>
                            </tr>
                        </table>
                        <table v-else style="width:100%">
                            <tr v-for="(product, index) in productList" :key="'tooltip-prod' + index" class="tooltip-table-data">
                                <td class="text-center"><a class="fa fa-times fa-lg" style="color:red" v-on:click.prevent="removeProduct(index)"/></td>
                                <td><strong>{{product.qtd}}</strong></td>
                                <td class="text-center tooltip-img"><img :src="product.imgSrc"></td>
                                <td class="tooltip-description"><strong>{{product.descr}}</strong></td>
                                <td class="text-center"><strong>{{formatCurrency(product.price)}}</strong></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="list-bottom">
                <div class="row">
                    <div class="col-md-6">
                        <span class="list-foot">Total (com impostos): {{formatCurrency(totalKombi)}}</span>
                    </div>
                    <div v-if="isConsumoProprio" class="col-md-6">
                        <button aria-label="Abrir meu Carrinho" class="btn btn-warning pull-right" v-on:click.prevent="openCart()">Abrir meu Carrinho</button>
                    </div>
                    <div  v-if="!isConsumoProprio" class="col-md-6">
                        <button aria-label="Abrir minha Cotação" v-if="isQuotation && !isVendaDireta && !isConsumoProprio" class="btn btn-warning pull-right" v-on:click.prevent="openCart()">Abrir minha Cotação</button>
                        <button aria-label="Abrir meu Carrinho" v-else-if="!isQuotation && !isVendaDireta && !isConsumoProprio" class="btn btn-primary pull-right" v-on:click.prevent="openCart()">Abrir meu Carrinho</button>
                        <button aria-label="Abrir meu Carrinho Venda Direta" v-else-if="isVendaDireta && !isQuotation && !isConsumoProprio" class="btn btn-primary pull-right" v-on:click.prevent="openCart()">Abrir meu Carrinho Venda Direta</button>
                        <button aria-label="Abrir minha Cotação Venda Direta" v-else-if="isVendaDireta && isQuotation && !isConsumoProprio" class="btn btn-warning pull-right" v-on:click.prevent="openCart()">Abrir minha Cotação Venda Direta</button>
                        <button aria-label="Abrir minha Cotação Venda Direta" v-else-if="!isVendaDireta && !isQuotation && isConsumoProprio" class="btn btn-primary pull-right" v-on:click.prevent="openCart()">Abrir meu Carrinho Ativo/Imobilizado</button>
                        <button aria-label="Abrir minha Cotação Ativo/Imobilizado" v-else class="btn btn-primary pull-right" v-on:click.prevent="openCart()">Abrir minha Cotação Ativo/Imobilizado</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="tooltip-body">
            <div class="row">
                <p class="empty-text">Procure os produtos que você deseja, clique em [ Comprar ] para inserí-los no meu Carrinho!</p>
            </div>
        </div>
    </div>
</template>
<script>

import Loader from '../Loader'

export default {
    name: "KombiTooltip",
    mounted(){
        this.refreshValues();
    },
    data(){
        return {
            hasKombi: true,
            isQuotation: false,
            session:{},
            loading: true,
            isVendaDireta: false,
            isConsumoProprio: false
        }
    },
    props: [
        'productList',
        'totalKombi'
    ],
    methods: {
        refreshValues: function(){
            var self = this;
            let session = JSON.parse(localStorage.getItem('usuarioLogado'));

            if (session && session.DadosCliente != null) {
                this.session = session;
                if (localStorage.getItem('GetTipoPedido') != null) {
                    if (localStorage.getItem('GetTipoPedido').includes('DIRETA'))
                        self.isVendaDireta = true
                    else if (localStorage.getItem('GetTipoPedido').includes('IMOBILIZADO'))
                        self.isConsumoProprio = true
                }

                if (session.CodigoPedido === -1 && session.CodigoOrcamento === -1) {
                    self.hasKombi = false;
                    self.loading = false;
                }
                else if (session.CodigoPedido != -1) {
                    self.isQuotation = false;
                    self.hasKombi = true;
                    self.isConsumoProprio = session.consumoProprio;
                    self.loading = false;
                }
                else if (session.CodigoOrcamento != -1) {
                    self.isQuotation = true;
                    // console.log("Aqui");
                    jQuery(".tooltip-table-data").addClass("quotation");
                    self.hasKombi = true;
                    self.loading = false;
                }
            }
            else {
                this.loading = false;
                this.hasKombi = false;
            }

        },
        formatCurrency: function(v) {
            //formata valores floats para moeda
            var formato = {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL"
            };
            return parseFloat(v).toLocaleString("pt-BR", formato);
        },
        removeProduct: function(prodIndex){

            const self = this;
            let produtoatual = {};
            this.productList.forEach(function(element, index){
                        if(prodIndex == index){
                            produtoatual = element;
                        }
            });
            swal({
                title: "Exclusão de produto " + produtoatual.codeDv,
                text: "Confirma a exclusão?",
                buttons: ["Cancelar", "Excluir"],
                dangerMode: true,
                })
            .then((willDelete) => {
                if (willDelete) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200){
                            if(xhr.responseText != "" && xhr.responseText != null){
                                self.$parent.$parent.$parent.getList();
                            }
                        } else {
                            // console.log("state:", xhr.readyState, " status:", xhr.status);
                        }
                    }
                    xhr.open("POST", this.$apiUrl + "Carrinho.svc/RemoverProduto");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({
                        codigoPedido: this.isQuotation ? this.session.CodigoOrcamento : this.session.CodigoPedido,
                        prd_codigo: produtoatual.code,
                        cdCliente: this.session.DadosCliente.CliCodigo,
                        nrFilial:1
                    }));
                } else {
                    return;
                }
                this.carregaDataLayer(produtoatual);
            });
        },
        openCart: function(){
            const self = this
            if (self.isConsumoProprio) {
                location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`;
            }
            else {
                if (this.isQuotation && !this.isVendaDireta && !this.isConsumoProprio) {
                    location.href = `${self.$SiteUrl}/loja/meu-carrinho/cotacao`;
                }
                else if (this.isVendaDireta && !this.isQuotation && !this.isConsumoProprio) {
                    location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`;
                }
                else if (this.isVendaDireta && this.isQuotation && !this.isConsumoProprio) {
                    location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/cotacao`;
                }
                else {
                    location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`;
                }
            }

        },
        carregaDataLayer(value) {
          if (dataLayer) {
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
              event: "remove_from_cart",
              ecommerce: {
                  items: [{
                  item_name: value.descr,
                  item_id: value.codeDv,
                  price: value.price,
                  item_brand: value.descr,
                  item_qtd: value.qtd
                  }]
              }
              });
          }
        },
    }
}
</script>

